import { useEffect, useState } from 'react';

// Returns a perctage of position down the page
const useScrollPosition = () => {
  const [percentageScrolled, setPercentageScrolled] = useState(0);
  const [windowScrollY, setWindowScrollY] = useState(0);

  useEffect(() => {
    const updatePosition = () => {
      setPercentageScrolled(window.scrollY / (document.body.scrollHeight - window.innerHeight));

      setWindowScrollY(window.scrollY);
    };

    // Measure once after the first layout to avoid a forced reflow during hydration; later updates come from scroll only.
    const bodyResizeObserver = new ResizeObserver(() => {
      bodyResizeObserver.disconnect();
      updatePosition();
    });
    bodyResizeObserver.observe(document.body);
    window.addEventListener('scroll', updatePosition);
    return () => {
      bodyResizeObserver.disconnect();
      window.removeEventListener('scroll', updatePosition);
    };
  }, []);

  return { percentageScrolled, windowScrollY };
};

export default useScrollPosition;
